






















import { Vue, Component, Watch } from 'vue-property-decorator'
import { TestEntry, TestJson } from './testset'

import TestRunner from '@/pages/TestRunner.vue'
import TestEditor from '@/pages/TestEditor.vue'

import { p64Encode, p64Decode } from '@/utils/p64'

import './style.scss'

type AppMode = 'runner' | 'editor'

function emptyTestJson (): TestJson {
  return {
    label: '',
    entries: [],
    comparisonPerPair: 1
  }
}

@Component({
  components: {
    TestRunner,
    TestEditor
  }
})
export default class extends Vue {
  testJson = emptyTestJson()

  testResult: TestEntry[] = []
  appMode: AppMode = 'editor'
  jsonUrl: string | null = null

  mounted (): void {
    if (location.hash) {
      this.testJson = JSON.parse(p64Decode(location.hash.substr(1)))
      if (/[?&]edit/.test(location.search)) {
        this.appMode = 'editor'
      } else {
        this.appMode = 'runner'
      }
    }
  }

  setMode (mode: AppMode): void {
    this.appMode = mode
  }

  @Watch('testJson', { deep: true })
  onTestJsonChange (s: TestJson): void {
    location.href = `#${p64Encode(JSON.stringify(s))}`
  }
}
